import _ from "@lodash";
import XAPPService from "app/Core/services/XAPPService";
import Constante from "Constante.json";
export const WEBEX_TOOGLE_MEETING = "[WEBEX APP] WEBEX TOOGLE MEETING";
export const WEBEX_INFO = "[WEBEX APP] WEBEX INFO";
export const WEBEX_WARNING = "[WEBEX APP] WEBEX WARNING";
export const WEBEX_ERROR = "[WEBEX APP] WEBEX ERROR";
export const WEBEX_PRELOAD = "[WEBEX APP] WEBEX PRELOAD";
export const WEBEX_GET_TOKEN = "[WEBEX APP] WEBEX GET TOKEN";
export const WEBEX_GET_CHAVE_INTEGRACAO = "[WEBEX APP] WEBEX GET CHAVE INTEGRACAO";
export const WEBEX_GET_PARTICIPANTS = "[WEBEX APP] WEBEX GET PARTICIPANTS";

window.openedWindow = null;

export function createMeeting(_ADados, _AIntegracao = null, _AParams, _AChave) {

   _ADados.enabledAutoRecordMeeting = false;
   _ADados.allowAnyUserToBeCoHost = false;
   _ADados.enabledJoinBeforeHost = false;
   _ADados.enableConnectAudioBeforeHost = false;
   _ADados.excludePassword = false;
   _ADados.publicMeeting = false;
   _ADados.enabledWebcastView = false;
   _ADados.enableAutomaticLock = false;
   _ADados.allowFirstUserToBeCoHost = false;
   _ADados.allowAuthenticatedDevices = false;
   _ADados.unlockedMeetingJoinSecurity = "allowJoinWithLobby";

   return (dispatch) => {
      dispatch(changePreload(true));
      if (_.isUndefined(_AIntegracao.access_token) || _.isNull(_AIntegracao.access_token)) {
         dispatch(autorizar(_ADados.idpessoaformulario, _AParams, 0, _AChave));
         return null;
      }
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
         "Authorization",
         "Bearer " + _AIntegracao.access_token
      );
      fetch("https://webexapis.com/v1/meetings", {
         method: "post",
         headers: myHeaders,
         body: JSON.stringify(_ADados),
      })
         .then((resp) => {
            resp.clone().json()
               .then((response) => {
                  if (!_.isUndefined(response.errors) && !_.isNull(response.errors) && response.errors.length > 0) {
                     switch (response.errors[0].description) {
                        case "Parameter 'start' or 'end' is before current time.": {
                           return dispatch({
                              type: WEBEX_ERROR,
                              payload: "O parâmetro 'inicio' ou 'termino' é anterior à hora atual.",
                           });
                        }
                        case "The request requires a valid access token set in the Authorization request header.": {
                           dispatch(refreshToken(_ADados, _AIntegracao, _AParams, createMeeting));
                           break;
                        }
                        default: {
                           return dispatch({
                              type: WEBEX_ERROR,
                              payload: response.errors[0].description,
                           });
                        }
                     }
                  } else if (!_.isUndefined(response.id)) {
                     let AResponse = {
                        id: response.id,
                        title: response.title,
                        meetingLink: response.webLink,
                        meetingNumber: response.meetingNumber,
                        sipAddress: response.sipAddress,
                     };
                     return dispatch({
                        type: WEBEX_INFO,
                        payload: "Operação realizada com sucesso!",
                        agendado: AResponse,
                     });
                  }
               });
         })
         .catch((error) => {
            console.log(error);
            return dispatch({
               type: WEBEX_ERROR,
               payload: "Ocorreu um erro durante a integração webex, informe o administrador do sistema.",
            });
         });
   };
}

export function deleteMeeting(_ADados, _AIntegracao, _AParams) {
   return (dispatch) => {
      dispatch(changePreload(true));
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
         "Authorization",
         "Bearer " + _AIntegracao.access_token
      );
      fetch("https://webexapis.com/v1/meetings/" + _ADados.id, {
         method: "delete",
         headers: myHeaders,
      })
         .then((resp) => {
            if (resp.status === 204) {
               return dispatch({
                  type: WEBEX_INFO,
                  payload: "Operação realizada com sucesso!",
                  agendado: null,
               });
            }
            else {
               resp.clone().json()
                  .then((response) => {
                     if (!_.isUndefined(response.errors) && !_.isNull(response.errors) && response.errors.length > 0) {
                        switch (response.errors[0].description) {
                           case "The request requires a valid access token set in the Authorization request header.": {
                              dispatch(refreshToken(_ADados, _AIntegracao, _AParams, deleteMeeting));
                              break;
                           }
                           default: {
                              console.log(response.errors[0].description);
                              return dispatch({
                                 type: WEBEX_ERROR,
                                 payload: "Ocorreu um erro durante a integração webex, informe o administrador do sistema.",
                              });
                           }
                        }
                     }
                  });
            }
         })
         .catch((error) => {
            console.log(error);
            return dispatch({
               type: WEBEX_ERROR,
               payload: "Ocorreu um erro durante a integração webex, informe o administrador do sistema.",
            });
         });
   };
}

export function autorizar(_AIDPessoaFormulario, _AParams, _ACriarConta, _AChave) {
   const AScope = "meeting:schedules_read meeting:schedules_write meeting:recordings_read meeting:recordings_write meeting:preferences_read meeting:preferences_write meeting:controls_read meeting:controls_write meeting:participants_read meeting:participants_write meeting:admin_participants_read spark-admin:telephony_config_read spark-admin:telephony_config_write meeting:admin_schedule_read meeting:admin_schedule_write meeting:admin_recordings_read meeting:admin_recordings_write meeting:admin_transcripts_read meeting:admin_preferences_write meeting:admin_preferences_read spark-compliance:meetings_read meeting:transcripts_read spark-compliance:meetings_write spark-admin:workspace_locations_read spark-admin:workspace_locations_write spark-admin:workspace_metrics_read spark-admin:broadworks_billing_reports_read spark-admin:broadworks_billing_reports_write spark:all spark-admin:devices_read spark-admin:devices_write spark-admin:licenses_read spark-admin:organizations_read spark-admin:organizations_write spark-admin:people_read spark-admin:people_write spark-admin:places_read spark-admin:places_write spark-admin:resource_group_memberships_read spark-admin:resource_group_memberships_write spark-admin:resource_groups_read spark-admin:roles_read spark-admin:call_qualities_read spark-admin:workspaces_read spark-admin:workspaces_write spark-compliance:events_read spark-compliance:memberships_read spark-compliance:memberships_write spark-compliance:messages_read spark-compliance:messages_write spark-compliance:rooms_read spark-compliance:rooms_write spark-compliance:team_memberships_read spark-compliance:team_memberships_write spark-compliance:teams_read spark-admin:broadworks_enterprises_read identity:placeonetimepassword_create Identity:one_time_password spark-compliance:webhooks_write spark-compliance:webhooks_read spark:calls_write spark-admin:wholesale_billing_reports_read spark-admin:hybrid_clusters_read spark-admin:wholesale_billing_reports_write spark-admin:hybrid_connectors_read spark-admin:broadworks_subscribers_read spark-admin:broadworks_subscribers_write analytics:read_all audit:events_read spark-admin:wholesale_customers_write spark-admin:wholesale_customers_read spark-admin:wholesale_subscribers_write spark-admin:wholesale_subscribers_read spark-admin:video_mesh_api_read identity:groups_rw identity:groups_read  spark-admin:video_mesh_api_webhook_write spark-admin:video_mesh_api_write spark-admin:locations_write identity:tokens_read identity:tokens_write spark-admin:locations_read spark-admin:broadworks_enterprises_write";
   const AState = JSON.stringify({
      tipo: "webex",
      xapp_token: "Bearer " + sessionStorage.getItem("jwt_access_token"),
      empresa: _AParams.empresa,
      usuario: sessionStorage.getItem("username"),
      idpessoaformulario: _AIDPessoaFormulario,
   });

   let AURL = `https://webexapis.com/v1/authorize?response_type=code&client_id=${_AChave}&scope=${AScope}&state=${btoa(AState)}`;
   if (_ACriarConta === 1) {
      AURL = "https://cart.webex.com/sign-up?experienceType=Unified&ft=selfsignup&theme=dark&ft=skipProvCheck&locale=pt-BR";
   }
   window.openedWindow = window.open(AURL, "popup", "width=600,height=600");
   return (dispatch) => {
      setTimeout(() => {
         dispatch(getToken(_AIDPessoaFormulario, _AParams));
      }, 10000);
   };
}

export function refreshToken(_ADados, _AIntegracao, _AParams, _ACallback = null) {
   return (dispatch) => {
      const AState = {
         tipo: "webex",
         empresa: _AParams.empresa,
         usuario: sessionStorage.getItem("username"),
         xapp_token: sessionStorage.getItem("jwt_access_token"),
         idpessoaformulario: _ADados.idpessoaformulario,
         refresh_token: _AIntegracao.refresh_token,
      };
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch("/api/integracao?code=1&" + new URLSearchParams(AState), {
         method: "get",
         headers: myHeaders,
      }).then(resp => {
         if (resp.status === 200) {
            resp.json().then((response) => {
               if (!_.isNull(_ACallback)) {
                  dispatch(_ACallback(_ADados, response.data, _AParams));
               }
               dispatch(getToken(_ADados.idpessoaformulario, _AParams));
            });
         }
         else {
            dispatch({ type: WEBEX_GET_TOKEN, payload: null });
            dispatch(changePreload());
         }
      }).catch(error => {
         var AJsonErro = JSON.parse(error);
         alert(AJsonErro.message);
      });
   };
}

export function clearReducer() {
   return {
      type: WEBEX_INFO,
      info: null,
      agendado: null,
   };
}

export function getToken(_AIDPessoaFormulario, _AParams, _ACallback = null) {

   return (dispatch) => {

      var AConditionsAND = [
         { "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario },
         { "Campo": "integracao.tipo", "Operador": "=", "Valor": Constante.webex }, { "Campo": "integracao.idpessoa", "Operador": "=", "Valor": _AParams.empresa }
      ];
      var AConditionsOR = [];
      var AActions = [];

      AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TokenWebex", AActions, "spvwintegracao", ["setup"], "SELECIONAR", AConditionsAND, AConditionsOR);

      AConditionsAND = [{ "Campo": "constante.chave", "Operador": "=", "Valor": location.host.includes("local") ? "WEBEX_ID_local" : "WEBEX_ID" }];
      AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "IntegracaoWebex", AActions, "spvwconstante", ["valor"], "SELECIONAR", AConditionsAND, AConditionsOR);


      XAPPService.XappSelAction(AActions, _AParams, "SEL")
         .then((response) => {
            Promise.all([
               dispatch({
                  type: WEBEX_GET_TOKEN,
                  Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                  payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
               }),
               dispatch({
                  type: WEBEX_GET_CHAVE_INTEGRACAO,
                  Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                  payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data[0].valor : "",
               })
            ]);

            if (!_.isNull(_ACallback) && response.data && response.data.length > 0 && !_.isNull(JSON.parse(response.data)[0].data)) {
               _ACallback();
            }
         })
         .catch(error => {
            return dispatch({
               type: WEBEX_ERROR,
               payload: error
            });
         });
   };
}

export function getParticipants(_AIntegracao, _AID) {
   return (dispatch) => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
         "Authorization",
         "Bearer " + _AIntegracao.access_token
      );
      fetch("https://webexapis.com/v1/meetingParticipants?meetingId=" + _AID, {
         method: "get",
         headers: myHeaders,
      })
         .then((resp) => {
            resp.clone().json()
               .then((response) => {
                  Promise.all([
                     dispatch({
                        type: WEBEX_GET_PARTICIPANTS,
                        payload: response.items,
                     })
                  ]);
               });
         })
         .catch((error) => {
            console.log(error);
            return dispatch({
               type: WEBEX_ERROR,
               payload: "Ocorreu um erro durante a integração webex, informe o administrador do sistema.",
            });
         });
   };
}

export function updateParticipants(_AIntegracao, _AID, _AADmit) {
   return (dispatch) => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
         "Authorization",
         "Bearer " + _AIntegracao.access_token
      );
      fetch("https://webexapis.com/v1/meetingParticipants/" + _AID, {
         method: "put",
         headers: myHeaders,
         body: JSON.stringify({ "admit": _AADmit }),
      })
         .then((resp) => {
            resp.clone().json()
               .then((response) => {
                  Promise.all([
                     dispatch({
                        type: WEBEX_GET_PARTICIPANTS,
                        payload: response.items,
                     })
                  ]);
               });
         })
         .catch((error) => {
            console.log(error);
            return dispatch({
               type: WEBEX_ERROR,
               payload: "Ocorreu um erro durante a integração webex, informe o administrador do sistema.",
            });
         });
   };
}

export function toogleMeeting() {
   return {
      type: WEBEX_TOOGLE_MEETING
   };
}

function changePreload(_AValue = false) {
   return {
      type: WEBEX_PRELOAD,
      payload: _AValue
   };
}
